// extracted by mini-css-extract-plugin
module.exports = {"chromeframe":"Project_chromeframe__l6XjY","main":"Project_main__E0dRr"};